import clsx from 'clsx'
import '../../styles/slp.css'

export interface RadioOption {
  value: string
  label: string
  disabled?: boolean
}

/**
 * SLP Channel-Setup style radio group — compact vertical list of radio rows
 * (e.g. the realtime stream bitrate picker: 64/128/192/256 kbit/s mono,
 * 192 stereo, 128 L/R split). Blue accent radios, light row hover.
 */
export function RadioGroupPanel({
  name,
  options,
  value,
  onChange,
  legend,
  className,
}: {
  /** Unique group name (radio `name` attribute + testid suffix). */
  name: string
  options: RadioOption[]
  value: string
  onChange: (value: string) => void
  /** Optional small heading above the rows, e.g. "Receive settings". */
  legend?: string
  className?: string
}) {
  return (
    <fieldset data-testid={`rt-radio-${name}`} className={clsx('m-0 border-0 p-0', className)}>
      {legend ? (
        <legend className="mb-1 p-0 text-[12px] font-semibold text-[var(--slp-text-dim)]">{legend}</legend>
      ) : null}
      <div className="flex flex-col">
        {options.map((opt) => (
          <label
            key={opt.value}
            className={clsx(
              'flex cursor-pointer items-center gap-2 rounded px-1.5 py-[3px] text-[13px] text-[var(--slp-text)]',
              'hover:bg-[var(--slp-panel-2)]',
              opt.disabled && 'cursor-not-allowed opacity-45',
            )}
          >
            <input
              type="radio"
              name={name}
              value={opt.value}
              checked={value === opt.value}
              disabled={opt.disabled}
              onChange={() => onChange(opt.value)}
              className="h-3.5 w-3.5"
              style={{ accentColor: 'var(--slp-blue)' }}
            />
            <span>{opt.label}</span>
          </label>
        ))}
      </div>
    </fieldset>
  )
}
